<accordion>
  @for (item of customerNotes; track item; let i = $index) {
    <accordion-group class="list-accounts" #accGroup
      [isOpen]="accGroup?.isOpen || isSelectedCustomerNote(item)">
      <span accordion-heading>
        <div class="account-items font-13 d-flex align-items-center {{ item.subCustomerNotes.length == 0?'last-level':''}}">
          @if (item.subCustomerNotes.length !== 0) {
            <button class="btn" type="button" id="{{item.id}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"
            [ngClass]="{'pl-5': item.subCustomerNotes.length === 0}">
            {{item.name}}
          </span>
          <input
            type="checkbox"
            (click)="$event.stopPropagation()"
            (change)="changeNoteStatus(item, $event)"
            class="account-checkbox ml-2"
            [disabled]="item.mandatory"
            [checked]="isSelectedCustomerNote(item)">
          </div>
        </span>
        @if (item.subCustomerNotes.length !== 0) {
          <div>
            <app-customer-note-node [customerNotes]="item.subCustomerNotes"
              [selectedCustomerNotes]="selectedCustomerNotes"
              (onAddCustomerNote)="addCustomerNote($event)"
              (onDeleteCustomerNote)="deleteCustomerNote($event)">
            </app-customer-note-node>
          </div>
        }
      </accordion-group>
    }
  </accordion>